export default __webpack_public_path__ + "static/media/Car4.30acb76a.jpg";